import React, { useState } from "react";
import { Col, Row } from "antd";
import { Cards } from "../../common/frame/cards-frame";
import { RegionSalesChart } from "../Charts/chartjs";
import Statistics from "../Charts/Statistics";
import TopMasterByProduct from "./TopMasterByProduct";
import ProductSales from "./ProductSales";
import { LineChartMonthly } from "../Charts/LineChartMonthly";
import { LineChartYear } from "../Charts/LineChartYear";
import { KotelDashboard } from "./KotelDashboard";
import { MasterRegionChart } from "./MasterRegionChart";
import { DeadMasterRegionChart } from "./DeadMasterRegionChart";
import { LineChartMonthlyType } from "../Charts/LineChartMonthlyType";
import { LineChartYearType } from "../Charts/LineChartYearType";
import Kvarts from "./Kvarts";

function Dashboard() {
  const [chart, setChart] = useState("day");

  const handleMonthClick = () => {
    setChart("day");
  };

  const handleYearClick = () => {
    setChart("month");
  };

  return (
    <>
      <div
        style={{ background: "#eef1ff", marginTop: "-0.4rem" }}
        className="p-3"
      >
        <Statistics />
        <Row>
          <Col md={24}>
            <Cards title="Продажа" size="large">
              <LineChartMonthly
                request={true}
                url="/services/admin/api/dashboard-requests-daily/"
              />
            </Cards>
          </Col>
          <div className="wrapper-container">
            <Cards title="По месяцам" size="large">
              <RegionSalesChart
                className="foo"
                style={{ marginBottom: "20px" }}
              />
            </Cards>
            <Cards title="По регионам">
              <KotelDashboard
                className="foo"
                style={{ marginBottom: "20px" }}
              />
            </Cards>
          </div>
          <div className="wrapper-container">
            <Cards title="Продавцы по регионам" size="large">
              <MasterRegionChart
                className="foo"
                style={{ marginBottom: "20px" }}
              />
            </Cards>
            <Cards title="Спящие продавцы по регионам" size="large">
              <DeadMasterRegionChart
                className="foo"
                style={{ marginBottom: "20px" }}
              />
            </Cards>
          </div>
          <div className="wrapper-container-full">
            <div className="masters-container">
              <Cards
                headStyle={{ fontSize: 14 }}
                title="Топ 10 по продажам"
                bodypadding="0"
              >
                <TopMasterByProduct />
              </Cards>
            </div>
          </div>
          <div className="wrapper-container-full">
            <div className="products-container">
              <Cards
                headStyle={{ fontSize: 14 }}
                title="Продажа продуктов"
                bodypadding="0"
              >
                <ProductSales />
              </Cards>
            </div>
          </div>
          <div className="wrapper-container-full">
            <div className="products-container">
              <Cards
                headStyle={{ fontSize: 14 }}
                title="Квартальный отчет"
                bodypadding="0"
              >
                <Kvarts />
              </Cards>
            </div>
          </div>

          <Col md={24}>
            <Cards title="Зарегистрированные продавцы" size="large">
              <div className="d-flex justify-content-end">
                <button
                  className="mr-2 text-white btn h-30px btn-bg-success d-flex align-items-center"
                  onClick={handleMonthClick}
                >
                  День
                </button>
                <button
                  className="text-white btn h-30px btn-bg-success d-flex align-items-center"
                  onClick={handleYearClick}
                >
                  Месяц
                </button>
              </div>
              {chart === "day" && (
                <LineChartMonthlyType
                  request={false}
                  url="/services/admin/api/dashboard-masters-reg-daily/"
                />
              )}
              {chart === "month" && (
                <LineChartYear
                  request={false}
                  url="/services/admin/api/dashboard-masters-reg-monthly/"
                />
              )}
            </Cards>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default Dashboard;
